module.exports = __webpack_public_path__ + "img/한끗인데5억을태워.5446194d.png";